<template>
  <div class="product-grid">
    <ul>
      <li v-for="item in list" :key="item.id">
        <div class="favorite-action" @click.prevent="toggleFavorite(item)">
           <svg v-if="isFavorite(item)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#ff0000" width="24px" height="24px"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
           <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" width="24px" height="24px"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
        </div>
        <router-link :to="{ path: '/goods/details', query: {productID:item.id} }">
          <div class="product-image-wrap">
            <img :src="item.img_path" alt />
            <span v-if="item.price != item.discount_price" class="product-badge">-{{ discountPercent(item) }}%</span>
          </div>
          <h2>{{ item.name }}</h2>
          <h3>{{ item.title }}</h3>
          <p>
            <span class="sale-price">{{ item.discount_price }} ₹</span>
            <span v-show="item.price != item.discount_price" class="del">{{ item.price }}₹</span>
          </p>
        </router-link>
      </li>
      <li v-if="isMore && list && list.length" class="more-tile">
        <router-link :to="{ path: '/goods', query: {categoryID:categoryIDs} }">
          More
          <i class="el-icon-d-arrow-right"></i>
        </router-link>
      </li>
    </ul>
  </div>
  </template>
  <script>
  import { mapGetters } from 'vuex'
  import * as favoriteAPI from '@/api/favorites'
  export default {
    name: 'ProductGrid',
    props: {
      list: {
        type: Array,
        default: () => []
      },
      isMore: {
        type: Boolean,
        default: false
      },
      cols: {
        type: Number,
        default: 4
      }
    },
    data() {
      return {
        favoriteProductIds: new Set()
      }
    },
    computed: {
      ...mapGetters(['getUser']),
      categoryIDs() {
        const ids = []
        if (this.list && this.list.length) {
          for (let i = 0; i < this.list.length; i++) {
            const id = this.list[i].category_id
            if (!ids.includes(id)) ids.push(id)
          }
        }
        return ids
      }
    },
    watch: {
      getUser: {
        handler() {
          this.initFavorites()
        },
        immediate: true
      },
      cols: {
        handler(val) {
          this.$el.style.setProperty('--grid-cols', val)
        },
        immediate: true
      }
    },
    methods: {
      discountPercent(item) {
        if (!item.price || !item.discount_price || item.price <= 0) return 0
        return Math.round((1 - item.discount_price / item.price) * 100)
      },
      isFavorite(item) {
        return this.favoriteProductIds.has(item.id)
      },
      initFavorites() {
        if (this.getUser) {
          // Logged in: fetch from API
          favoriteAPI.showFavorites(this.getUser.id, 0, 100).then(res => {
            if (res.status === 200) {
              const ids = res.data.items.map(item => item.id)
              this.favoriteProductIds = new Set(ids)
            }
          }).catch(err => {
            // console.error('Failed to fetch favorites', err)
          })
        } else {
          // Not logged in: fetch from localStorage
          const localFavorites = JSON.parse(localStorage.getItem('localFavorites') || '[]')
          this.favoriteProductIds = new Set(localFavorites)
        }
      },
      toggleFavorite(item) {
        if (this.isFavorite(item)) {
          // Remove favorite
          this.favoriteProductIds.delete(item.id)
          this.favoriteProductIds = new Set(this.favoriteProductIds) // Trigger reactivity
          
          if (this.getUser) {
            favoriteAPI.deleteFavorite({
              user_id: this.getUser.id,
              product_id: item.id
            }).then(res => {
              if (res.status === 200) {
                this.$message.success('Removed from favorites')
              }
            })
          } else {
            const localFavorites = Array.from(this.favoriteProductIds)
            localStorage.setItem('localFavorites', JSON.stringify(localFavorites))
          }
        } else {
          // Add favorite
          this.favoriteProductIds.add(item.id)
          this.favoriteProductIds = new Set(this.favoriteProductIds) // Trigger reactivity
          
          if (this.getUser) {
            favoriteAPI.postFavorite({
              user_id: this.getUser.id,
              product_id: item.id
            }).then(res => {
              if (res.status === 200) {
                this.$message.success('Added to favorites')
              } else {
                 this.$message.error(res.msg)
                 this.favoriteProductIds.delete(item.id)
                 this.favoriteProductIds = new Set(this.favoriteProductIds)
              }
            })
          } else {
            const localFavorites = Array.from(this.favoriteProductIds)
            localStorage.setItem('localFavorites', JSON.stringify(localFavorites))
          }
        }
      }
    }
  }
  </script>
  <style scoped>
  .product-grid {
    --grid-cols: 4;
  }
  .product-grid ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
  }
  .product-grid ul li {
    position: relative;
    flex: 0 0 calc((100% - 14px * (var(--grid-cols, 4) - 1)) / var(--grid-cols, 4));
    width: calc((100% - 14px * (var(--grid-cols, 4) - 1)) / var(--grid-cols, 4));
    max-width: calc((100% - 14px * (var(--grid-cols, 4) - 1)) / var(--grid-cols, 4));
    min-width: 0;
    box-sizing: border-box;
    min-height: 420px;
    padding: 12px;
    background-color: #ffffff;
    border-radius: 14px;
    border: 1px solid #eceef1;
    transition: all 0.2s linear;
  }
  .favorite-action {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 10;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    transition: all 0.2s ease;
  }
  .favorite-action:hover {
    transform: scale(1.1);
    background-color: #ffffff;
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  }
  .product-grid ul li a {
    display: block;
    width: 100%;
    color: inherit;
  }
  .product-grid ul li:hover {
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
    transform: translate3d(0, -2px, 0);
  }
  .product-image-wrap {
    position: relative;
    width: 100%;
  }
  .product-grid ul li img {
    display: block;
    width: 100%;
    height: 380px;
    background: url(https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop4/769005590/71ZwId6uZlL._SY879_-430x574.jpg) no-repeat 50%;
    border-radius: 12px;
    object-fit: cover;
  }
  .product-badge {
    position: absolute;
    top: 10px;
    left: 10px;
    background: linear-gradient(135deg, #4338CA 0%, #3730A3 100%);
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 6px;
    letter-spacing: 0.3px;
    z-index: 5;
  }
  .product-grid ul li h2 {
    margin: 12px 0 0;
    font-size: 14px;
    font-weight: 600;
    color: #111111;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    max-width: 100%;
  }
  .product-grid ul li h3 {
    margin: 6px 0 0;
    height: 18px;
    font-size: 11px;
    font-weight: 400;
    color: #6b7280;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
  }
  .product-grid ul li p {
    margin: 10px 0 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    color: #111111;
    font-weight: 600;
  }
  .product-grid ul li p .sale-price {
    color: #4338CA;
    font-size: 16px;
    font-weight: 700;
  }
  .product-grid ul li p .del {
    color: #9ca3af;
    text-decoration: line-through;
  }
  .more-tile {
    display: flex;
    min-height: 420px;
    align-items: center;
    justify-content: center;
    border: 1px dashed #C4B5FD;
  }
  .more-tile a {
    font-size: 14px;
    color: #4338CA;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  }
  .more-tile a:hover {
    color: #3730A3;
  }
  @media (max-width: 900px) {
    .product-grid ul { gap: 12px; }
    .product-grid ul li,
    .more-tile {
      flex: 0 0 calc((100% - 12px) / 2);
      width: calc((100% - 12px) / 2);
      max-width: calc((100% - 12px) / 2);
      min-height: 340px;
      padding: 10px;
    }
    .product-grid ul li img {
      height: 260px;
    }
  }
  </style>
